import BottomCTA from "@/components/BottomCTA/BottomCTA";
import Container from "@/components/Container/Container";
import FeatureSection from "@/components/FeatureSection/FeatureSection";
import Layout from "@/components/Layout/Layout";
import Testimonials from "@/components/Testimonial/Testimonials";
import {
  Heading,
  H5Css,
  H2Css,
  Body,
  BodyRegular14Css,
  BodyMedium20Css,
} from "@/components/Typography";
import { mq } from "@/constants/breakpoints";
import { css } from "@emotion/react";
import Balancer from "react-wrap-balancer";
import { darkColor } from "@/constants/colors";
import { getFeaturePage } from "@/utils/getFeaturePage";
import MoreFeaturesSectionContentful from "@/components/FeatureSection/MoreFeaturesSectionContentful";
import addEventsImage from "../../../public/images/features/scheduling/add-events-e.png";
import createTeamSchedulesImage from "../../../public/images/features/scheduling/create-team-schedules-e.png";
import displayEventsImage from "../../../public/images/features/scheduling/display-events-e.png";
import googleMapsIcon from "../../../public/images/features/scheduling/google-maps-icon.svg";
import organizeBanquetsIcon from "../../../public/images/features/scheduling/organize-banquets-icon.svg";
import promoteFundraisersIcon from "../../../public/images/features/scheduling/promote-fundraisers-icon.svg";
import scheduleEventsIcon from "../../../public/images/features/scheduling/schedule-events-icon.svg";
import GetStartedButton from "@/components/Buttons/GetStartedButton";
import PageFAQSection from "@/components/PageFAQSection";
import HeroImage from "@/components/HeroImage";

const Page = ({ fields }: any) => {
  const {
    // heroImage,
    heroTitle,
    heroSubtitle,
    sectionsCollection,
    summaryHeading,
    summaryItemsCollection,
    pageTitle,
    metaDescription,
  } = fields;

  return (
    <>
      <Layout
        title={pageTitle}
        metaDescription={metaDescription}
        heroContainerCss={css`
          background: url(/images/features/scheduling/BG.svg), #daf2ff;
          background-size: cover;
          background-repeat: no-repeat;
        `}
        hero={
          <Container>
            <div
              css={css`
                text-align: center;
                margin-top: 22px;
                color: #fff;
                display: flex;
                flex-direction: column;
                ${mq["lg"]} {
                  margin-top: 70px;
                  flex-direction: row;
                }
              `}
            >
              <div
                css={css`
                  ${mq["lg"]} {
                    flex: 1.5;
                    margin-top: 40px;
                  }
                `}
              >
                <Heading
                  level={1}
                  css={css`
                    ${H5Css}
                    color: ${darkColor};
                    ${mq["lg"]} {
                      ${H2Css}
                      text-align: left;
                    }
                  `}
                >
                  <Balancer>{heroTitle}</Balancer>
                </Heading>
                <Body
                  css={css`
                    margin-top: 14px;
                    color: ${darkColor};
                    ${BodyRegular14Css}
                    ${mq["lg"]} {
                      text-align: left;
                      margin-top: 24px;
                      ${BodyMedium20Css}
                    }
                  `}
                >
                  <Balancer>{heroSubtitle}</Balancer>
                </Body>
                <div
                  css={css`
                    width: fit-content;
                    display: block;
                    margin: auto;
                    ${mq["lg"]} {
                      margin: unset;
                    }
                  `}
                >
                  <div
                    css={css`
                      margin: 28px auto 0;
                      ${mq["lg"]} {
                        margin: 40px 0 0;
                      }
                    `}
                  >
                    <GetStartedButton />
                  </div>
                </div>
              </div>
              <div
                css={css`
                  margin-top: 75px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                  ${mq["md"]} {
                    flex: 1;
                  }
                  ${mq["lg"]} {
                    margin-top: 0;
                    height: 502px;
                    margin-right: calc(-1 * ((100vw - 1024px) / 2 + 40px));
                  }
                  ${mq["xl"]} {
                    margin-top: auto;
                    height: auto;
                    margin-right: calc(-1 * ((100vw - 1192px) / 2 + 40px));
                  }
                  ${mq["xl2"]} {
                    margin-top: auto;
                    height: auto;
                  }
                `}
              >
                <HeroImage
                  images={{
                    xs: fields.heroImageXs.url,
                    sm: fields.heroImageSm.url,
                    md: fields.heroImageMd.url,
                    lg: fields.heroImageLg.url,
                    xl: fields.heroImageXl.url,
                    xl2: fields.heroImageXl2.url,
                  }}
                  alt="Youth Sports Scheduling Software"
                />
              </div>
            </div>
          </Container>
        }
      >
        {sectionsCollection.items.map((item: any, index: number) => {
          let images;
          switch (index) {
            case 0:
              images = { desktopImage: addEventsImage };
              break;
            case 1:
              images = { desktopImage: createTeamSchedulesImage };
              break;
            case 2:
              images = { desktopImage: displayEventsImage };
              break;
          }

          return (
            <FeatureSection
              key={index}
              sectionSEOText={
                index === 0 ? "SPORTS SCHEDULING SOFTWARE" : undefined
              }
              imageFirst={index % 2 === 1}
              desktopImage={images?.desktopImage}
              sectionHeadline={item.sectionTitle}
              feat1Headline={item.item1Title}
              feat1Body={item.item1Description}
              feat2Headline={item.item2Title}
              feat2Body={item.item2Description}
              feat3Headline={item.item3Title}
              feat3Body={item.item3Description}
              feat4Headline={item.item4Title}
              feat4Body={item.item4Description}
            />
          );
        })}
        <div
          css={css`
            margin-top: 60px;
          `}
        />
        <MoreFeaturesSectionContentful
          summaryHeading={summaryHeading}
          summaryItemsCollection={summaryItemsCollection}
          tlIcon={googleMapsIcon}
          trIcon={scheduleEventsIcon}
          blIcon={promoteFundraisersIcon}
          brIcon={organizeBanquetsIcon}
        />
        <Testimonials testimonials={fields.testimonialsCollection.items} />
        <div
          css={css`
            margin-top: 60px;
          `}
        >
          <BottomCTA />
        </div>
        <div
          css={css`
            margin-top: 60px;
            ${mq["lg"]} {
              margin-top: 120px;
              margin-bottom: 120px;
            }
          `}
        >
          <PageFAQSection
            faqItems={
              fields?.faqSection?.questionsAndAnswersCollection?.items || []
            }
          />
        </div>
      </Layout>
    </>
  );
};

export const getStaticProps = async (): Promise<{
  props: any;
}> => {
  const { fields } = await getFeaturePage("Scheduling");

  return { props: { fields } };
};

export default Page;
